export * from './number-badge.component';
